import dynamic from "next/dynamic";

export const DynamicContent064 = dynamic(() => import("./Content064"), {
  suspense: true,
});
